const preferencesFilters = ['km_unlimited', 'international', 'vehicle_height', 'less_than_five', 'winter_tire', 'winter_chain', 'automatic_gear', 'licence_type', 'owner_types', 'is_ambassador', 'review_average__gte', 'pets', 'disabled_access', 'instant_booking', 'smoking'] as const

export type SearchPreferenceForm = Pick<SearchFilters, (typeof preferencesFilters)[number]>

export const useSearchFiltersPreferencesForm = (formRef: Ref<SearchPreferenceForm> | undefined = undefined) => {
  const { filters } = storeToRefs(useSearchStore())

  const formPreferences = formRef === undefined
    ? ref<SearchPreferenceForm>({
        km_unlimited: false,
        international: false,
        vehicle_height: false,
        less_than_five: false,
        winter_tire: false,
        winter_chain: false,
        automatic_gear: false,
        licence_type: null,
        owner_types: null,
        is_ambassador: false,
        review_average__gte: null,
        pets: false,
        disabled_access: false,
        instant_booking: false,
        smoking: undefined,
      })
    : formRef

  const initFormPreferences = () => {
    for (const key of preferencesFilters) {
      (formPreferences.value as Record<string, any>)[key] = filters.value[key]
    }
  }

  const vehicleSmokingDisallowed = computed({
    get() {
      return formPreferences.value.smoking === false ? true : false
    },
    set(value) {
      if (value === true) {
        formPreferences.value.smoking = false
      }
      else {
        formPreferences.value.smoking = undefined
      }
    },
  })

  return {
    formPreferences,
    vehicleSmokingDisallowed,
    initFormPreferences,
  }
}
